import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete-report-dialog',
  templateUrl: './confirm-delete-report-dialog.component.html',
  standalone: false
})
export class ConfirmDeleteReportDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { reportDate: string }
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
